"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "Click here to expand the group members": "Cliquez ici pour développer les membres du groupe",
  "Click here to view the group members": "Cliquez ici pour afficher les membres du groupe",
  "Company, {company}": ["Entreprise, ", ["company"]],
  "Contact card, {name}": ["Carte de contact, ", ["name"]],
  "Department, {department}": ["Service, ", ["department"]],
  "Email, {emailAddress}": ["E-mail, ", ["emailAddress"]],
  "Expand members": "Développer les membres",
  "Group - {members, plural, one {# member} other {# members}}": ["Groupe : ", ["members", "plural", {
    one: ["#", " membre"],
    other: ["#", " membres"]
  }]],
  "Mobile phone, {mobilePhone}": ["Téléphone portable, ", ["mobilePhone"]],
  "Mobile: {mobilePhone}": ["Portable : ", ["mobilePhone"]],
  "Name, {name}": ["Nom, ", ["name"]],
  "Title, {title}": ["Fonction, ", ["title"]],
  "Type to search": "Saisissez le ou les termes à rechercher",
  "View members": "Afficher les membres",
  "Work phone, {workPhone}": ["Téléphone professionnel, ", ["workPhone"]],
  "Work: {workPhone}": ["Bureau : ", ["workPhone"]]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map